/* import __COLOCATED_TEMPLATE__ from './aside.hbs'; */
import Component from '@glimmer/component';
import { GEOS } from 'core/utils/constants';
import { service } from '@ember/service';
import { variation } from 'ember-launch-darkly';

const { US, EU } = GEOS;

/**
 *
 * `HcpMarketingAside` component is used to display HashiCorp Cloud Platform branding
 * and marketing information. It does not take any arguments.
 * All content is located within the component itself.
 *
 *
 * ```
 * <HcpMarketing::Aside />
 * ```
 *
 * @class HcpMarketingAside
 *
 */

export default class HcpMarketingAside extends Component {
  @service config;

  REGION_EU = EU;

  get deployGeo() {
    return this.config.app?.deployGeo ?? US;
  }

  get enterpriseNavEnabled() {
    return variation('hcp-ui-enterprise-nav');
  }

  get containerClassNames() {
    const classes = ['hcp-marketing-aside'];

    if (this.enterpriseNavEnabled) {
      classes.push('enterprise-nav');
    }

    if (this.deployGeo === this.REGION_EU) {
      classes.push('eu');
    }

    return classes.join(' ');
  }

  // @deprecated
  // should be removed after enterprise nav goes live
  get classNames() {
    const classes = ['hcp-dashboard-screenshot-background'];

    if (!variation('hvs-eos-eol')) {
      classes.push('hcp-dashboard-screenshot-background--with-hvs');
    }

    if (this.deployGeo === this.REGION_EU) {
      classes.push('hcp-dashboard-screenshot-background--eu');
    }

    return classes.join(' ');
  }
}
